module.exports = __webpack_public_path__ + "static/media/landing-kitty07.5ea93b07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/landing-kitty07.svg
// module id = 122
// module chunks = 0